module.exports = __webpack_public_path__ + "img/main-fishing.6c7123cc.png";